import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import { useState } from 'react';

export function CouponItemInfo({
  name,
  price,
  showQuantitySelector,
  onQuantityChange,
}) {
  const [quantity, setQuantity] = useState(1);
  const total = quantity * price;

  const updateQuantity = (newQ) => {
    setQuantity(newQ);
    if (onQuantityChange) {
      onQuantityChange(newQ); // notify parent
    }
  };

  return (
    <Card className="w-full max-w-md rounded-lg shadow-sm">
      <CardHeader>
        <h2 className="text-xl font-bold text-[#1F4B81]">
          Apmokėjimo informacija
        </h2>
      </CardHeader>

      <CardContent className="space-y-4">
        {/* Product Row */}
        <div className="flex justify-between items-center mb-2.5">
          <span className="text-gray-700">{name}</span>
          <span className="font-semibold text-[#1F4B81]">{total} €</span>
        </div>

        {/* Quantity Selector */}
        {showQuantitySelector && (
          <div className="flex items-center space-x-2 mb-2.5">
            <span className="text-xs sm:text-sm text-gray-500 uppercase">
              Kiekis
            </span>

            <div className="flex items-center border rounded-md bg-white overflow-visible">
              <Button
                type="button"
                variant="ghost"
                className="h-8 w-8 sm:h-9 sm:w-9 p-0 flex items-center justify-center"
                onClick={() => updateQuantity(Math.max(1, quantity - 1))}
              >
                −
              </Button>

              <span className=" w-6 sm:w-8 text-center text-sm sm:text-base font-medium select-none">
                {quantity}
              </span>

              <Button
                type="button"
                variant="ghost"
                className="h-8 w-8 sm:h-9 sm:w-9 p-0 flex items-center justify-center"
                onClick={() => updateQuantity(quantity + 1)}
              >
                +
              </Button>
            </div>
          </div>
        )}
      </CardContent>

      <Separator />

      <CardFooter className="flex justify-between items-center">
        <span className="font-medium">Iš viso su PVM</span>
        <span className="font-bold text-[#1F4B81]">{total} €</span>
      </CardFooter>
    </Card>
  );
}
